import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Timeline from './components/Timeline';
import Specs from './components/Specs';
import Goodbye from './components/Goodbye';
import Legacy from './components/Legacy';
import Footer from './components/Footer';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <Timeline />
      <Specs />
      <Goodbye />
      <Legacy />
      <Footer />
    </div>
  );
};

export default App;
